import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchNewsList(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/news', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        // Lee los metadatos del enlace para precargar el formulario.
        fetchLinkPreview(ctx, { url }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/news/preview', { url })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchNews(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/news/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        createNews(ctx, { payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/news/create', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateNews(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/news/${id}/update`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        desactivateNews(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/news/${id}/desactivate`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        activateNews(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/news/${id}/activate`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteNews(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/news/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
